import { scrollbarStyle } from '@niaratech/niara-react-components/src/util/scrollbarStyle'
import styled, { css } from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

type PaymentInfoProps = {
  justifyContent?: string
}
export const PaymentInfo = styled.div<PaymentInfoProps>`
  align-items: center;
  display: flex;
  gap: 5px;
  ${({ justifyContent }) => `justify-content: ${justifyContent}};`}
  cursor: pointer;
  width: 100%;

  b {
    flex: 0;
  }

  & img {
    width: 16px;
    height: 16px;
  }
`

export const ConditionsContainer = styled.div`
  justify-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

type IconInfoProps = {
  centered?: boolean
}
export const IconInfo = styled.div<IconInfoProps>`
  display: flex;
  cursor: pointer;
  padding-top: 5px;
  /* height: 100%; */
  color: ${({ theme }) => theme?.colors?.textColor};
  ${({ centered }) =>
    centered &&
    css`
      align-items: center;
      justify-content: center;
    `}
`
export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const Text = styled.p`
  line-height: normal;
  margin: 0;
  white-space: break-spaces;

  font-size: 14px;
`

export const TextDescription = styled.p`
  /* color: ${({ theme }) => theme?.colors?.white}; */
  font-family: 'Manrope';
  font-size: 12px;
  line-height: normal;
  margin: 0;
  padding-bottom: 10px;
`

export const CardIcons = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 5px;
  margin-top: 10px;
  width: 100%;
`

export const TypePaymentVertical = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`

export const TypeOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  flex: 1;
`

type UnicTypesProps = {
  textColor?: string
  highlight?: boolean
}
export const UnicTypes = styled.div<UnicTypesProps>`
  color: ${({ theme, textColor, highlight }) =>
    highlight ? theme?.colors?.priceColor : textColor || theme?.colors?.textColor};
  display: flex;
  gap: 5px;
  cursor: pointer;
  align-items: center;
`

type TextTypePaymentProps = {
  textSize?: number
  fontWeight?: number | string
  ellipsis?: boolean
}
export const TextTypePayment = styled.p<TextTypePaymentProps>`
  font-family: 'Manrope';
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : '12px')};
  font-weight: ${({ fontWeight }) => fontWeight || '400'};
  margin: 0;

  ${({ ellipsis }) =>
    ellipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    `}
`

export const ResponsiveTooltipContainer = styled.div`
  max-width: 90%;
`

export const PaymentLine = styled.p<{
  textSize?: number
  textColor?: string
  fontWeight?: number | string
  ellipsis?: boolean
}>`
  margin: 0;
  align-items: center;
  color: ${({ theme, textColor }) => textColor || theme?.colors?.textColor};
  display: flex;
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : '12px')};
  font-weight: ${({ fontWeight }) => fontWeight || '400'};

  ${({ ellipsis }) => {
    if (ellipsis) {
      return css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 180px;
        display: block;
      `
    }
  }}
`

export const MorePayments = styled.p<{ textSize?: number }>`
  font-weight: 600;
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : '12px')};
  color: ${({ theme }) => theme?.colors?.info};
  margin: 0;
`

export const ToolTipPaymentOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* padding: 10px; */
  min-width: 240px;
  max-height: 400px;
  overflow-y: auto;

  ${scrollbarStyle}
`

export const ToolTipPaymentOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* color: ${({ theme }) => theme?.colors?.white}; */
`

export const ToolTipPaymentOptionHeader = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 19.12px;
  max-width: 219px;
`
export const ToolTipPaymentOptionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const ToolTipPaymentOptionFooter = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.5px;
`

export const ToolTipTotalByPaymentOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* padding: 10px; */
  max-height: 400px;
`
export const ToolTipTotalByPaymentOptionContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  /* color: ${({ theme }) => theme?.colors?.white}; */
`
export const ToolTipTotalByPaymentOptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme?.colors?.white};

  & .paymentOption {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.39px;
    white-space: nowrap;
  }

  & .bestPrice {
    padding: 4px 5px;
    gap: 10px;
    border-radius: 4px;
    font-size: 9px;
    font-weight: 600;
    line-height: 10px;
    background-color: ${({ theme }) => theme?.colors?.priceColor};
    white-space: nowrap;
  }
`

export const ToolTipTotalByPaymentOptionValue = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 16.5px;
`
